import { createContext } from 'react'
import { DialogueStore } from '@/store/types'

/**
 * 对话上下文
 */
export const DialogContext = createContext<DialogueStore | null>(null)

